import React, { useState, useCallback, useEffect } from 'react';
import styles from './BaseLayout.module.scss';

import { IBaseLayoutProps } from './interface';

// Components
import AgeGate from '../AgeGate';
import BaseFooter from '../BaseFooter';
import Screensaver from '../Screensaver';

import { useAppSelector } from '../../../app/hooks';

const BaseLayout: React.FC<IBaseLayoutProps> = (props: IBaseLayoutProps) => {
    const { children } = props;
    const sessionToken = useAppSelector((state) => state.users.sessionToken);

    const [key, setKey] = useState(0);
    const handleScreensaverStateChange = useCallback(() => {
        setKey((prevKey) => prevKey + 1);
    }, []);

    useEffect(() => {
        if (sessionToken === null) handleScreensaverStateChange();
    }, [sessionToken]);

    return (
        <div className={styles.wrapper}>
            <header className="sr-only">
                <h1>50.000 de premii și experiențe</h1>
            </header>
            <main>
                <div className={styles.absoluteBackgroundNoArtists} />
                <React.Fragment key={key}>{children}</React.Fragment>
            </main>
            <BaseFooter internalLayout={true} />

            <AgeGate />
            <Screensaver onStateChange={handleScreensaverStateChange} />
        </div>
    );
};

export default BaseLayout;
